import { render, staticRenderFns } from "./ConformanceType.vue?vue&type=template&id=ed29e1cc&"
import script from "./ConformanceType.vue?vue&type=script&lang=js&"
export * from "./ConformanceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports